import { PathEnum } from '@/i18n/locale-config';
import { useRouter } from '@/i18n/navigation';
import { useUserStore } from '@/store/useUserStore';
import { cn } from '@/utils/tailwind-merge';
import { LogOut } from 'lucide-react';
import { useTranslations } from 'next-intl';

export default function LogoutButton({ onClick, className }: { onClick?: () => void; className?: string }) {
    const t = useTranslations('Auth');
    const router = useRouter();

    const { logout } = useUserStore();

    const handleLogout = () => {
        if (onClick) {
            onClick();
        }
        logout();
        router.replace(PathEnum.Home);
    };

    return (
        <button onClick={handleLogout} className={cn("flex items-center w-fit hover:text-pink-light transition-colors duration-300", className)}>
            <LogOut className="rotate-180 text-pink-light max-lg:w-6 max-lg:h-6" />
            <span className="pl-3 uppercase text-p">{t('logout')}</span>
        </button>
    );
}
